import type { Button, ButtonOverlay } from "./contentItemSchemas";
import {
  buttonFieldsSchema,
  buttonOverlayFieldsSchema,
  parseButtonFromFields,
  parseButtonOverlayFromFields,
  parseWithRecord,
} from "./schemas";

export const parseButton = (item: unknown, formLabel?: string): Button => {
  const parsed = parseWithRecord(item, buttonFieldsSchema);
  return parseButtonFromFields(parsed, formLabel);
};

export const parseButtonOverlay = (
  item: unknown,
  formLabel?: string,
): ButtonOverlay => {
  const parsed = parseWithRecord(item, buttonOverlayFieldsSchema);
  return parseButtonOverlayFromFields(parsed, formLabel);
};
